import { ApiKey, BaseUrl } from '../global'
import axios from 'axios'

export const getDestinations = async (source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/internationalbooking/Destinations',
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}


export const getLocations = async (uid, accountNo, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/internationalbooking/Locations' + `?uid=${uid}&accountNo=${accountNo}`, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}


export const getCountries = async () => {
    try {
        const rs = await axios.get(BaseUrl + 'api/internationalbooking/Countries', {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

export const getServices = async (source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/internationalbooking/Services', {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

export const getNTN = async (uid, accountNo, locationid, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/internationalbooking/GetNTN' + `?uid=${uid}&accountNo=${accountNo}&locationid=${locationid}`, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}


export const save = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/internationalbooking/Save', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}